import { getStoreId, getLanguageWithCountry } from 'src/utils/BasePathTools';

/**
 * Returns base parameters common to all coanalyt events.
 */
export const getBaseParams = () => ({
	displayLanguage: getLanguageWithCountry() || 'en-GB',
	storeId: getStoreId(),
});
